var map = {
	"./Food-1.png": 7443,
	"./Food-2.png": 4232,
	"./Food-3.png": 4177,
	"./Food-4.png": 8062,
	"./Food-5.png": 5751,
	"./Food-6.png": 7276,
	"./Food-7.png": 3813,
	"./Food-8.png": 8162
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4473;